var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResendArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.984,
    height: 14.92,
    viewBox: "0 0 16.984 14.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_237",
    "data-name": "Rect\\xE1ngulo 237",
    width: 16.984,
    height: 14.92,
    fill: "#9e3667"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_236",
    "data-name": "Rect\\xE1ngulo 236",
    width: 16.399,
    height: 14.343,
    fill: "#9e3667"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1520",
    "data-name": "Grupo 1520",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1385",
    "data-name": "Grupo 1385",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1384",
    "data-name": "Grupo 1384",
    transform: "translate(0.293 0.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1383",
    "data-name": "Grupo 1383",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1382",
    "data-name": "Grupo 1382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1381",
    "data-name": "Grupo 1381",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1476",
    "data-name": "Trazado 1476",
    d: "M16.583,6.217a.266.266,0,0,1,0,.358l-5.635,5.89a.269.269,0,0,1-.37.012.273.273,0,0,1-.081-.185V8.446c-5.485,0-9.458.312-7.806,6.144A5.723,5.723,0,0,1,.254,9.832C.254,4.7,5.474,4.347,10.5,4.347V.5a.259.259,0,0,1,.266-.254.3.3,0,0,1,.185.081Z",
    transform: "translate(-0.254 -0.247)",
    fill: "#9e3667"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendArrow);
export default __webpack_public_path__ + "static/media/ResendArrow.27d1d4dac56d2fc493e5ba87b0c9490e.svg";
export { ForwardRef as ReactComponent };